module.exports = require('./lib/seq-queue');